export const TRACKING = {
  SCHEMAS: {
    EXPERIMENT_CHOKEPOINT_SCHEMA: 'experiment_choke_point.ExperimentChokePoint',
    SMART_METRIC_SCHEMA: 'experiment_smart_metrics.SmartMetric',
  },
  MESSAGES: {
    EXPERIMENT_CHOKEPOINT: 'ExperimentChokePoint',
    SMART_METRIC: 'SmartMetric',
  },
};
